// Centralized API base resolver to avoid CORS by preferring same-origin routing
// while still honoring REACT_APP_BACKEND_URL when it matches current host.

let RAW = '';
try {
  RAW = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BACKEND_URL) || '';
} catch (_) {
  RAW = '';
}

let API_BASE = '/api';
try {
  if (RAW) {
    const rawUrl = new URL(RAW);
    const isLocalhost = typeof window !== 'undefined' && window.location && 
                       (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    const sameHost = typeof window !== 'undefined' && window.location && rawUrl.host === window.location.host;
    
    // Use relative /api path for localhost (proxy) or same-host routing to avoid CORS
    API_BASE = (sameHost || isLocalhost) ? '/api' : `${RAW}/api`;
  }
} catch (e) {
  console.warn('[API Base] Error constructing API_BASE:', e);
  API_BASE = '/api';
}

export default API_BASE;
